export enum LEARNING_CORE {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=547942631
     */
    AVAILABLE_UNTIL_DATE = 'TRAINING_COURSE.AVAILABLE_UNTIL_DATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=548057156
     */
    DUE_ON_DATE = 'TRAINING_COURSE.DUE_ON_DATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=657024997
     */
    FLIP_CARD_BUTTON = 'TRAINING_COURSE.FLIP_CARD_BUTTON',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=549225134
     */
    HELPER_LOCKED_MODULE = 'TRAINING_COURSE.HELPER_LOCKED_MODULE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=549224964
     */
    HELPER_FAILED_MODULE = 'TRAINING_COURSE.HELPER_FAILED_MODULE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=436917839
     */
    LEARNING_PATH = 'LEARNING.LEARNING_PATH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=810787936
     */
    LEARNING_PATHS = 'LOOKER_LEARNING_LEARNING_PATHS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=629196306
     */
    LEARNING_TYPE = 'LEARNING_CORE.LEARNING_TYPE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=549906146
     */
    OVERDUE_SINCE_DATE = 'TRAINING_COURSE.OVERDUE_SINCE_DATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=550623647
     */
    SCORED_ACTIVITY = 'TRAINING_COURSE.SCORED_ACTIVITY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=695146461
     */
    SCORE_NUMBER = 'LEARNING_CORE.SCORE_NUMBER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=436888345
     */
    TRAINING_COURSE = 'LEARNING.TRAINING_COURSE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=859218668
     */
    BACK_TO_TRAINING = 'LEARNING_CORE.BACK_TO_TRAINING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=862063993
     */
    GET_IT_RIGHT = 'LEARNING_CORE.GET_IT_RIGHT',
}
